'use client';

import { CardWithTitle, Form } from '@packages/chakra-v3';

import { ForgotPasswordForm } from '../../components';
import { ForgotPasswordFormSchema } from '../../schemas';
import type { ForgotPasswordFormType } from '../../schemas';
import { useForgotPassword } from '../../hooks';

const ForgotPasswordContainer = () => {
	const { handleForgotPassword } = useForgotPassword();

	return (
		<CardWithTitle title={'Forgot Password'}>
			<Form.Provider<ForgotPasswordFormType>
				schema={ForgotPasswordFormSchema}
				onSubmit={handleForgotPassword}
			>
				<ForgotPasswordForm />
			</Form.Provider>
		</CardWithTitle>
	);
};

export default ForgotPasswordContainer;